export default "__VITE_ASSET__De3CDobj__"